







































import { Vue, Component } from 'vue-property-decorator'
import LogoButton from 'src/components/presenter/layout/LogoButton.vue'
import SearchDialog from 'src/components/presenter/search/SearchDialog.vue'
import MessengerDialog from 'src/components/messenger/Messenger.vue'
import ProfileSwitcher from 'components/account/ProfileSwitcher.vue'

@Component({
  components: {
    LogoButton,
    SearchDialog,
    MessengerDialog,
    ProfileSwitcher
  }
})
export default class PresenterLayoutTopMenu extends Vue {

}
